/* @flow */

export function normalizeString(str : string) : string {
    return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, '').replace(/[^a-z0-9A-Z]+/g, '_');
}



// WEBPACK FOOTER //
// ./src/lib/util.js